module.exports = __webpack_public_path__ + "img/6.fb070d1e.jpg";